import React, { useState } from 'react';
import { Footer, HeaderNavi, SupportLeftMenu } from '@components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleUp, faAngleDown } from '@fortawesome/free-solid-svg-icons';

const Qna = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const qnaData = [
    {
      question: 'Q1. 첫 번째 질문입니다.',
      answer: '첫 번째 질문에 대한 답변입니다.',
    },
    {
      question: 'Q2. 두 번째 질문입니다.',
      answer: '두 번째 질문에 대한 답변입니다.',
    },
    {
      question: 'Q3. 세 번째 질문입니다.',
      answer: '세 번째 질문에 대한 답변입니다.',
    },
    {
      question: 'Q4. 네 번째 질문입니다.',
      answer: '네 번째 질문에 대한 답변입니다.',
    },
    {
        question: 'Q4. 네 번째 질문입니다.',
        answer: '네 번째 질문에 대한 답변입니다.',
      },
      {
        question: 'Q4. 네 번째 질문입니다.',
        answer: '네 번째 질문에 대한 답변입니다.',
      },
      {
        question: 'Q4. 네 번째 질문입니다.',
        answer: '네 번째 질문에 대한 답변입니다.',
      },
      {
        question: 'Q4. 네 번째 질문입니다.',
        answer: '네 번째 질문에 대한 답변입니다.',
      },
      {
        question: 'Q4. 네 번째 질문입니다.',
        answer: '네 번째 질문에 대한 답변입니다.',
      },
  ];

  // 질문 클릭 시 활성화된 인덱스를 변경하는 함수
  const toggleQnaContent = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <main id="main" className="mainpage">
      <div>
        <div className="section main-contact">
          <HeaderNavi selectedCategory/>
          <div className="sub-container">
            <div className="sub-layout">
              <SupportLeftMenu />
              <div className="sub-contact">
                <h3 className="border-bt" style={{ marginBottom: '0' }}>Q & A</h3>

                <div style={{ padding: '10px' }}>
                  {qnaData.map((item, index) => (
                    <div key={index} style={{ marginBottom: '1rem' }}>
                      <div
                        className="agree-wrapper box-border"
                        style={{
                          marginTop: '2rem',
                          cursor: 'pointer',
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                        }}
                        onClick={() => toggleQnaContent(index)}
                      >
                        <span>{item.question}</span>
                        <FontAwesomeIcon icon={activeIndex === index ? faAngleUp : faAngleDown} />
                      </div>
                      {activeIndex === index && (
                        <div className="agree">
                          <p>{item.answer}</p>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </main>
  );
};

export default Qna;
